<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="840px">
        <div class="row">
            <div class="col-12 table-responsive">
                <table class="table text-left">
                    <thead>
                    <tr>
                        <th style="width: 120px">Método de pago</th>
                        <th style="width: 120px">Destino
                            <el-tooltip class="item"
                                        content="Aperture caja o cuentas bancarias"
                                        effect="dark"
                                        placement="top-start">
                                <i class="fa fa-info-circle"></i>
                            </el-tooltip>
                        </th>
                        <th style="width: 100px">Referencia</th>
                        <th style="width: 100px">Monto</th>
                        <th style="width: 30px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in payments" :key="index">
                        <td>
                            <x-select v-model="row.payment_method_type_id"
                                      :options="payment_method_types"
                                      @input="changePaymentMethodType(index)"></x-select>
                        </td>
                        <td>
                            <x-select v-model="row.cash_id"
                                      :options="all_cash"
                                      v-if="!row.has_bank_account"
                                      @input="changeCash(index)">
                            </x-select>
                            <x-select v-model="row.bank_account_id"
                                      :options="bank_accounts"
                                      @input="changeBankAccount(index)"
                                      v-else>
                            </x-select>
                        </td>
                        <td>
                            <x-input v-model="row.reference"></x-input>
                        </td>
                        <td>
                            <x-input v-model="row.payment"></x-input>
                        </td>
                        <td class="text-center">
                            <button v-if="index > 0"
                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                    type="button"
                                    @click.prevent="clickRemovePayment(index)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 text-center">
                <a href="#"
                   @click.prevent="clickAddPayment">
                    <i class="fa fa-plus font-weight-bold text-info"></i>
                    <span style="color: #777777">Agregar pago</span>
                </a>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit"
                                 :disabled="loading"
                                 text="Generar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";
import XInput from "../../../../components/Form/XInput.vue";
import XSelect from "../../../../components/Form/XSelect.vue";
import XDatePicker from "../../../../components/Form/XDatePicker.vue";
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue";
import moment from "moment/moment";

export default {
    name: 'DocumentPayment',
    components: {XInputItemSearch, XDatePicker, XSelect, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        data: {},
        formId: null,
        showLoadVoucher: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'store',
            errors: {},
            payments: [],
            payment_conditions: [],
            payment_method_types: [],
            payment_destinations: [],
            bank_accounts: [],
            all_cash: [],
        }
    },
    created() {
        this.initForm();
        this.initTables();
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.payments = [];
            this.loading = false;
        },
        async initTables() {
            await this.$http.get(`/${this.resource}/get_payment_tables`)
                .then(response => {
                    this.payment_conditions = response.data.payment_conditions;
                    this.payment_method_types = response.data.payment_method_types;
                    this.payment_destinations = response.data.payment_destinations;
                    this.bank_accounts = response.data.bank_accounts;
                    this.all_cash = response.data.all_cash;
                });
        },
        handleOpen() {
            this.initForm()
            if (this.formId) {
                this.data.payments.forEach(row => {
                    let payment_method_type = this.payment_method_types.find(p => {
                        return p.id === row.payment_method_type_id
                    })
                    let payment_destination_id = (row.cash_id !== null) ? 'cash' : row.bank_account_id
                    // payment_destination_id = (row.bank_account_id !== null) ? row.bank_account_id : null

                    this.payments.push({
                        id: null,
                        document_id: null,
                        date_of_payment: row.date_of_payment,
                        payment_method_type_id: row.payment_method_type_id,
                        reference: row.reference,
                        payment_destination_id: payment_destination_id,
                        payment: row.payment,
                        payment_received: row.payment_received,
                        filename: null,
                        temp_path: null,
                        cash_id: row.cash_id,
                        bank_account_id: row.bank_account_id,
                        file_list: [],
                        has_bank_account: payment_method_type.has_bank_account,
                        currency_type_id: row.currency_type_id,
                        exchange_rate_sale: this.data.exchange_rate_sale
                    })
                })
            } else {
                this.clickAddPayment()
                this.changePaymentMethodType(0)
            }
            this.title = 'Registrar Pagos'
        },
        clickAddPayment() {
            let _default = _.find(this.payment_method_types, {'is_default': true})
            let id = _default ? _default.id : '01'
            if (this.cash_payment_metod !== undefined &&
                this.cash_payment_metod[0] !== undefined) {
                id = this.cash_payment_metod[0].id
            }
            let total = 0;
            if (this.data.total_payment !== undefined) {
                total = this.data.total_payment
            }

            this.payments.push({
                id: null,
                document_id: null,
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: id,
                reference: null,
                payment_destination_id: null, //this.getPaymentDestinationId(),
                payment: total,
                payment_received: true,
                filename: null,
                temp_path: null,
                cash_id: null,
                bank_account_id: null,
                file_list: [],
                has_bank_account: false,
                currency_type_id: this.data.currency_type_id,
                exchange_rate_sale: this.data.exchange_rate_sale
            })
            this.calculatePayments()
        },
        clickRemovePayment(index) {
            this.payments.splice(index, 1);
            this.calculatePayments()
        },
        calculatePayments() {
            let payment_count = this.payments.length
            let total = this.data.total_payment// this.getTotal()
            let payment = 0
            let amount = _.round(total / payment_count, 2)
            _.forEach(this.payments, row => {
                payment += amount
                if (total - payment < 0) {
                    amount = _.round(total - payment + amount, 2)
                }
                row.payment = amount
            })
        },
        getPaymentDestinationId() {
            // let cash = _.find(this.payment_destinations, {'id': 'cash'})
            // return (cash) ? cash.id : this.payment_destinations[0].id
        },
        changePaymentMethodType(index) {
            let payment_method_type = _.find(this.payment_method_types, {'id': this.payments[index].payment_method_type_id})
            let has_bank_account = payment_method_type.has_bank_account
            this.payments[index].has_bank_account = has_bank_account
            if (has_bank_account) {
                if (this.bank_accounts.length > 0) {
                    this.payments[index].cash_id = null
                    this.payments[index].bank_account_id = this.bank_accounts[0].id
                }
            } else {
                if (this.all_cash.length > 0) {
                    this.payments[index].bank_account_id = null
                    this.payments[index].cash_id = this.all_cash[0].id
                }
            }
            this.changeCash(index)
            this.changeBankAccount(index)
        },
        changeCash(index) {
            if (this.payments[index].cash_id !== null) {
                this.payments[index].payment_destination_id = 'cash'
            }
        },
        changeBankAccount(index) {
            if (this.payments[index].bank_account_id !== null) {
                this.payments[index].payment_destination_id = this.payments[index].bank_account_id
            }
        },
        onSubmit() {
            let error = false
            let error_message = ''
            this.payments.forEach(p => {
                if (p.cash_id === null && p.bank_account_id === null) {
                    error = true
                    error_message = 'El destino es requerido, verificar la apertura de caja o cuentas bancarias'
                }
            })

            if (error) {
                this.$message.error(error_message);
                return
            }

            this.$emit('success', this.payments)
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
